import { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';

import useUserIdentity from 'hooks/useUserIdentity';
import useRoles from 'hooks/useRoles';
import useDedicatedAssignment from 'hooks/useDedicatedAssignment';
import useClock from 'hooks/useClock';
import useCollabs from 'hooks/useCollabs';

import { CollabProps } from 'stores/collab_store';

import IdentityAvatar from 'components/IdentityAvatar';
import AssistantOnly from 'components/AssistantOnly';

//import BreadcrumbLink from 'components/BreadcrumbLink';

const BreadCrumbs = () => {
    //  const { currentUser } = useAuth();

    //         <Typography

            // <Typography level="title-lg">Calendar Settings</Typography>
            // <Typography level="title-lg"><Link to={"/settings/calendar/preview"}>Preview</Link></Typography>

    return (
        <Stack direction="row"
            spacing={1}>

            {/*
            <BreadcrumbLink to={"/account"}
                iconName="ContactPageOutlined">Account</BreadcrumbLink>
            { currentUser.has_calendar &&
            <BreadcrumbLink to={"/account/calendar"}
                prefix={"/account/calendar"}
                iconName="CalendarMonth">Calendar</BreadcrumbLink> }
            <BreadcrumbLink to={"/account/calendar/settings"}
                prefix={"/account/calendar"}
                iconName="EditCalendar">Calendar Settings</BreadcrumbLink>
              */}
        </Stack>
    );
};


const DedicatedContainer = observer(() => {
    const { identityUuid } = useParams();

    const { currentIdentity } = useUserIdentity();
    const { hasRole } = useRoles();
    const { fetchCollab, getCollab, collabs } = useCollabs();
    const { isDedicatedFor, fetchDedicatedAssignmentsByAssistantIdentity } = useDedicatedAssignment();
    const [fetching, setFetching] = useState(false);
    const [collab, setCollab] = useState<CollabProps | null>(null);
    const { currentClock } = useClock();

    // make sure we set it if it changes
    useEffect(() => {
        if(currentClock?.associated_type == 'collab') {
            setCollab(getCollab(currentClock.associated_uuid));
        }
    }, [currentClock?.associated_type, currentClock?.associated_uuid, collabs.length]);

    // fetch collab for this clock if we're a collab
    useEffect(() => {
        if(!currentClock?.key) return;
        if(currentClock?.associated_type == 'collab') {
            fetchCollab(currentIdentity.key, currentClock?.associated_uuid || '');
            setCollab(getCollab(currentClock?.associated_uuid));
        }
    }, [currentClock?.key, getCollab]);

    useEffect(() => {
        if(!currentIdentity?.uuid) return;
        if(fetching) return;
        setFetching(true);
        fetchDedicatedAssignmentsByAssistantIdentity(currentIdentity.uuid)
            .finally(() => setFetching(false));
    }, [currentIdentity?.uuid]);

    if(!identityUuid) {
        return null;
    }

    // If we're loading...
    if(fetching) {
        return <Stack m={2}><em>Loading</em></Stack>;
    }

    // This person is not a dedicated!
    if(!(currentIdentity.dedicated || hasRole('manager'))) {
        return <Stack m={2}><em>Not dedicated (permission denied)</em></Stack>;
    }

    // Ok, we're dedicated, but are we dedicated for this person?
    if(!hasRole('manager')) {
        if(!isDedicatedFor(currentIdentity.uuid, identityUuid)) {
            console.log("not dedicated for");
            return <Stack m={2}><em>Not dedicated for this person (permission denied)</em></Stack>;
        }
    }

    return (
        <Stack>
            <Stack
                direction="row"
                justifyContent="space-between"
                sx={{
                        left: 0,
                        display: 'flex',
                        zIndex: 800,
                    }}
                py={1}
            >
                <Stack
                    direction="row"

                    spacing={1}
                    mx={2}
                    width="100%"
                    alignItems="center">

                    { !collab || !isDedicatedFor(currentIdentity.uuid, collab?.identity) &&
                        <IdentityAvatar
                            size="inline"
                            interactive="link"
                            identityKey={identityUuid} />
                    }

                    <BreadCrumbs />

                </Stack>
            </Stack>

            <AssistantOnly>
                <Outlet />
            </AssistantOnly>
        </Stack>
    );

});


export default DedicatedContainer;
